module.exports = __webpack_public_path__ + "img/home-v2-community-left.8f18129.webp";